import BrokenImage from '../../src/legacy/BrokenImage.tsx';
export default BrokenImage;
